import React from "react";
import { Routes, Route } from "react-router-dom";
import { LayoutAuth } from "../layout/LayoutAuth";
import { Login } from "../pages/auth/login";

export const AuthRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<LayoutAuth />}>
                <Route index element={<Login />} />
            </Route>
        </Routes>
    );
};
